import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { useCommonStore, usePageStore, useUserStore } from '@/store';
import util from '../../common/util';
import { colorBlock } from '../defaultSpacing';
import HouseFormat, { getProviderHtml } from '@/common/house';
import AttomDesc from '@/components/attom-desc.vue';
import { calcHouseLink } from '@/modules/md-house/useHouse';
const TAB_METHODS = ['getPropertyData', 'getSchoolData', 'getBusinessData'];
//  Control map display in different modes
const actionMaps = {
    'school-business': { tab: TAB_METHODS },
    nbrInfo: { tab: TAB_METHODS, boundary: true },
    'feature-area-info': { tab: TAB_METHODS, boundary: true }
    // 'detail-sold': {tab: ['getPropertyData', 'getSchoolData']},
    // 'detail': {tab: ['getPropertyData', 'getSchoolData']}
};
export const NBR_TYPE_NUM = {
    0: 'city',
    1: 'subdivision',
    2: 'community',
    3: 'area',
    4: 'neighborhood'
};
export default {
    i18next: {
        ns: 'md-map'
    },
    data: function() {
        return {
            title: '',
            mapData: {
                lat: 0,
                lng: 0,
                address: '',
                zoom: 14,
                url: '',
                hjId: '', // required by the interface hjId
                type: '' //city or neighborhood
            },
            listingWalkScore: null,
            boundaryColor: '#4c84ff',
            mapConfig: {
                mapTypeId: 'roadmap',
                scrollwheel: false,
                mapTypeControl: false
            },
            tools: [
                { name: 'zoom', css: 'right: 10px; bottom: 30px' },
                { name: 'maptype', css: 'left: 20px; top: 20px' }
            ],
            selectTab: '',
            houseLimit: 20,
            autoCenter: false,
            height: 0,
            mobileHeight: 0,
            mapChangeEvent: [],
            markerData: {},
            markerEventMap: {},
            normalMarkers: null,
            normalMarkerShow: true,
            tabs: [],
            showtabs: null,
            replace: false,
            showCollapse: true,
            replaceMapLoad: false,
            showDisclaimer: false,
            init: true,
            show: false,
            locationMarker: true,
            currentBoundaryIndex: -1,
            miles: 0,
            ...colorBlock,
            visible: false,
            mapType: '',
            canLoadMap: false
        };
    },
    created() {
        this.dataReset();
        this.psMap = new Promise(resolve => {
            this.psResolve = resolve;
        });
        if (this.replace && !this.center) {
            return; 
        }
        this.show = true;
    },
    beforeMount() {
        this.$nextTick(() => {
            this.canLoadMap = true;
        });
        if (!this.replace && !this.center && !this.address) {
            this.getCompanyInfo();
        }
        this.onLngNsLoaded('md-map').then(() => {
            if (!util.isSSRServer && this.mapData) {
                return Promise.all([
                    this.getData(),
                    this.getWalkScore(),
                    !this.hasSave && this.getUpData()
                ]);
            }
        });
    },
    computed: {
        ...rootMapState(usePageStore, {
            listingSearchSwitch: store => store.page.listingSearchSwitch,
            isCensusSubdivision: store =>
                store.page?.censusSubdivision || false,
            companyInfo: store => store.companyInfo,
            page: store => store.processedGlobalData
        }),
        ...rootMapState(useCommonStore, {
            windowHeight: store => store.windowSize.height
        }),
        ...rootMapState(useUserStore, ['userEmailVerified']),
        showGMap() {
            return this.replaceMapLoad || !util.isClient;
        },
        defaultAddress({ companyInfo }) {
            return companyInfo?.address || '';
        },
        mapShow({ center, address, defaultAddress }) {
            return center || address || defaultAddress;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        isHideSchoolMap() {
            return (
                this.isCensusSubdivision && this.mapType === 'school-business'
            );
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        contentStyle() {
            if (this.isMobileSize || !this.height) {
                return {};
            } else {
                //  The height of the map should be less than  windowHeight-100, Otherwise, other areas cannot be displayed in the visible area of the page ， page cannot be scrolled
                let windowHeight = util.isSSRServer
                    ? 0
                    : this.windowHeight - 100;
                return {
                    height: Math.min(this.height, windowHeight) + 'px'
                };
            }
        },
        containerStyle() {
            if (this.isMobileSize) {
                return {
                    height: this.mobileHeight ? this.mobileHeight + 'px' : ''
                };
            } else {
                return {};
            }
        },
        lat() {
            return +(this.mapData && this.mapData.lat) || 0;
        },
        lng() {
            return +(this.mapData && this.mapData.lng) || 0;
        },
        address({ defaultAddress, page, isFeatureArea }) {
            if (page.pageKey === 'neighborhood' || isFeatureArea) {
                return  (this.mapData && this.mapData.address) || '' // product: Wing Zhou  AM-363753
            }
            return (this.mapData && this.mapData.address) || defaultAddress
        },
        url() {
            return (this.mapData && this.mapData.url) || '';
        },
        zoom() {
            return (this.mapData && this.mapData.zoom) || 14;
        },
        center() {
            if (this.lat && this.lng) {
                return {
                    lat: parseFloat(this.lat),
                    lng: parseFloat(this.lng)
                };
            } else {
                return null;
            }
        },
        isFeatureArea({ page }) {
            return page.pageKey && page.pageKey.indexOf('featured-area') > -1;
        }
    },
    watch: {
        address() {
            this.locationMarker && this.updateLocationMarker();
        },
        center() {
            this.locationMarker && this.updateLocationMarker();
        },
        normalMarkerShow(value) {
            if (value && this.normalMarkers) {
                this.markerData = Object.assign({}, this.markerData, {
                    location: null,
                    aggregation: this.normalMarkers.aggregation,
                    city: this.normalMarkers.city
                });
            } else {
                this.markerData = Object.assign({}, this.markerData, {
                    location: null,
                    aggregation: null,
                    city: null
                });
            }
        }
    },
    methods: {
        ...rootMapActions(usePageStore, {
            getCompanyInfo: 'getCompanyInfo'
        }),

        dataReset() {
            // this.normalMarkers = null;
            this.normalMarkerShow = true;
            this.tabs = [];
            this.mapChangeEvent = [];
            this.markerData = {};
            this.markerEventMap = {};
            this.replaceMapLoad = false;
            this.showDisclaimer = false;
            this.show = false;
            this.init = true;
            this.locationMarker = true;
            this.currentBoundaryIndex = -1;
        },
        mapLoad(siteMap, map, maps) {
            this.siteMap = siteMap;
            this.map = map;
            this.maps = maps;
            this.psResolve(siteMap);
            this.updateLocationMarker();
        },
        mapClick(evt) {
            util.call(this.mapClickEvent, this, evt);
        },
        //  get the right Property of TabItem The data
        getPropertyData() {
            let url = `/api-site/property/${this.mapData.type}/${this.mapData.hjId}`;
            let params = {};
            if (this.page.pageKey.indexOf('featured-area') > -1) {
                url = `/api-searchcenter/featureArea/${this.page.siteId}/geoMap`;
                let area = this.featureArea.state;
                if (this.featureArea.city) {
                    area = this.featureArea.city + ', ' + area;
                }
                if (this.featureArea.neighborhood) {
                    area = this.featureArea.neighborhood + ', ' + area;
                }
                if (!this.page.searchCenter) {
                    params.siteId = this.page?.siteId;
                    url = `/api-nonsearchcenter/search/featureArea/geoMap`;
                    params.mlsOrgIds = this.page.mlsOrgs
                        .map(item => item.id)
                        .join(',');
                }
                params.areaType =
                    NBR_TYPE_NUM[this.featureArea.featureAreaType];
                params.area = area;
            }
            return this.axiosIns
                .get(url, { params })
                .then(res => {
                    return {
                        label: this.$t('md-map.properties'),
                        type: 'house',
                        data: res.data?.data || res.data || [],
                        moreLink:
                            this.moreLink?.nbrSearchUrl ||
                            this.moreLink?.citySearchUrl ||
                            res.data?.moreLink,
                        moreLabel: res.data?.moreLabel || res.moreLabel
                    };
                })
                .catch(e => {
                    console.error(e);
                });
        },
        //  get the right School of TabItem The data
        getSchoolData() {
            var url =
                this.mapData.type === 'city'
                    ? `/api-hj/hj-data/v1/city-schools?hjCityId=${this.mapData.hjId}&limit=100`
                    : `/api-hj/hj-data/v1/neighborhood-schools?hjNeighborhoodId=${this.mapData.hjId}&limit=100`;
            return this.axiosIns
                .get(url)
                .then(res => {
                    var groupMap = {};
                    res.schools.forEach(s => {
                        var schoolGroups = s.level.split(',');
                        //  each school can run multiple group
                        for (var i = 0; i < schoolGroups.length; i++) {
                            var group = schoolGroups[i];
                            if (group) {
                                if (!groupMap[group]) {
                                    groupMap[group] = {
                                        label: this.$t('md-map.groupSchools', {
                                            group
                                        }),
                                        data: []
                                    };
                                }
                                groupMap[group].data.push(s);
                            }
                            s.latitude = s.coordinatesLatitude;
                            s.longitude = s.coordinatesLongitude;
                        }
                    });
                    return {
                        label: this.$t('md-map.schools'),
                        type: 'school',
                        groups: Object.values(groupMap)
                    };
                })
                .catch(() => {});
        },
        //  get the right Business of TabItem The data
        getBusinessData() {
            var url =
                this.mapData.type === 'city'
                    ? `/api-hj/hj-data/v1/city-business?hjCityId=${this.mapData.hjId}`
                    : `/api-hj/hj-data/v1/neighborhood-business?hjNeighborhoodId=${this.mapData.hjId}`;
            return this.axiosIns
                .get(url)
                .then(res => {
                    var groupMap = {};
                    res.businessList.forEach(b => {
                        //  Here's a deduplication ,  because the data is unreliable ,  There are also repeated ....
                        var categories = Array.from(new Set(b.categoryList));
                        //  each school can run multiple group
                        for (var i = 0; i < categories.length; i++) {
                            var c = categories[i];
                            if (c) {
                                if (!groupMap[c]) {
                                    groupMap[c] = {
                                        label: c,
                                        data: [],
                                        index: Object.keys(groupMap).length
                                    };
                                }
                                groupMap[c].data.push(b);
                            }
                        }
                        b.group = groupMap[c];
                        b.latitude = b.coordinatesLatitude;
                        b.longitude = b.coordinatesLongitude;
                    });

                    return {
                        label: this.$t('md-map.business'),
                        type: 'business',
                        groups: Object.values(groupMap).sort((a, b) =>
                            a.index - b.index < 0 ? -1 : 1)
                    };
                })
                .catch(() => {});
        },
        //  Get the bounds when the page is initialized
        getBoundary() {
            const typeObj = {
                school: 'school',
                city: 'city',
                neighborhood: 'nbr'
            };
            let type = typeObj[this.mapData.type];
            return this.axiosIns
                .get(
                    `/api-hj/hj-data/v1/boundary?type=${type}&hjId=${this.mapData.hjId}`
                )
                .then(boundary => {
                    if (boundary?.data?.length > 0) {
                        this.psMap.then(() => {
                            let boundaryIndex = this.siteMap.setCenter(
                                null,
                                null,
                                boundary,
                                this.boundaryColor
                            );
                            this.siteMap.fitBoundary(boundaryIndex, () => {
                                this.siteMap.saveAsDefaultLocate();
                            }, false);
                        });
                    }
                });
        },
        /**
         * @return Promise
         */
        getData(zoom) {
            /**  Old interface in each mode
             * nbr: '/api-site/map/city/ed52b56b67e810d223e8e3144c8e845e'
             * nbrInfo: '/api-site/map-info/city/ed52b56b67e810d223e8e3144c8e845e/San-Jose?label=San+Jose%2C+CA'
             * school-business: '/api-site/schoolBusiness/city/ed52b56b67e810d223e8e3144c8e845e'
             * detail: '/api-site/listing/detailNearBy/999999999?page=1&pageSize=10&status=active'
             * detail-sold: '/api-site/listing/detailNearBy/999999999?page=1&pageSize=10&status=active'
             */
            return new Promise(async resolve => {
                let action = actionMaps[this.mapType];
                if (action) {
                    //  new interface logic
                    if (action.tab) {
                        //  load tab Page
                        let res = await Promise.all(
                            action.tab.map(it => this[it]())
                        )
                        let data = res.filter(it => {
                            if (it) {
                                return it.type === 'house'
                                    ? it.data && it.data.length > 0
                                    : it.groups && it.groups.length > 0;
                            }
                            return false;
                        });
                        this.initMapPanel(data);
                    }
                    if (action.boundary) {
                        await this.getBoundary();
                    }
                } else if (this.isFeatureArea) {
                    await this.getBoundary();
                    let res = await this.getPropertyData()
                    this.markerData.house = res.data;
                } else {
                    //  old interface logic
                    let url = this.url;
                    if (url) {
                        const params = util.getQueryField('', url);
                        url = url.replace(/\?.+/, '');
                        let data = { params };
                        if (zoom) {
                            data.params.zoom = Math.round(zoom);
                        }
                        if (this.miles) {
                            data.params.miles = this.miles;
                        }
                        try {
                            let res = await this.axiosIns.get(url, data)
                            const resData = res.data || {};
                            if (
                                this.onDataInit(resData, this.init) !==
                                false
                            ) {
                                this.initMapPanel(resData);
                            }
                        } catch (e) {
                            console.error(e)
                        } finally {
                            this.init = false;
                        }
                    }
                }
                resolve()
            });
        },
        //  render map data
        onDataInit(data, init) {
            if (util.isArray(data)) {
                // right display panel
                //  If only the mobile  business  The data ,  don't show map
                if (
                    data.length === 1 &&
                    data[0].type === 'business' &&
                    this.isMobileSize
                ) {
                    this.show = false;
                    this.sidebarOptions = null;
                    return false;
                }
            } else {
                if (init && data.tabs) {
                    this.initMapPanel(data.tabs);
                }
                if (data.markers) {
                    this.normalMarkers = data.markers;
                    data.tabs &&
                        this.selectTab &&
                        (this.normalMarkerShow = false);
                    data = data.markers;
                }
                this.psMap.then(() => {
                    if (init) {
                        if (data.reFetch || data.aggregation) {
                            const map = this.map;
                            let oldZoom = Math.round(map.getZoom());
                            this.markerEventMap = Object.assign(
                                {},
                                this.markerEventMap
                            );
                            this.mapChangeEvent = this.mapChangeEvent.concat([
                                () => {
                                    const nowZoom = Math.round(map.getZoom());
                                    if (nowZoom !== oldZoom) {
                                        oldZoom = nowZoom;
                                        this.getData(nowZoom);
                                    }
                                }
                            ]);
                        }
                        if (data.envelope) {
                            this.siteMap.setZoom(data.envelope, null, true);
                        }
                    }
                    if (data.boundary) {
                        this.siteMap.addBoundary(
                            data.boundary,
                            this.boundaryColor,
                            { clear: true }
                        );
                    }
                });
                if (this.normalMarkerShow) {
                    this.locationMarker = false;
                    let markerData = Object.assign({}, this.markerData, {
                        location: null,
                        house: data.house,
                        city: data.city
                    });
                    if (!this.isFeatureArea) {
                        markerData.aggregation = data.aggregation
                    }
                    this.markerData = markerData;
                }
                return false;
            }
        },
        calcIsShowMask(houseData) {
            return houseData.isProtected && !this.userEmailVerified;
        },
        initMapPanel(data) {
            const tabs = [];
            let flag = true;
            for (let i = 0, len = data.length; i < len; i++) {
                const item = data[i];
                if (
                    (item.data && item.data.length > 0) ||
                    (item.groups && item.groups.length > 0)
                ) {
                    let type = item.type;
                    if (!type) {
                        type = item.type = 'school';
                    }
                    if (this.showtabs && this.showtabs.indexOf(type) === -1) {
                        continue;
                    }
                    if (type === 'house') {
                        item.data = item.data || item.searchResult || [];
                        item.data.forEach(data => {
                            let houseData = HouseFormat.call(this, data, this.page);
                            // vow
                            data.isShowMask = this.calcIsShowMask(houseData);
                            data.link = calcHouseLink(houseData);
                            data.provided = this.listingSearchSwitch
                                ? data.mlsOrg?.cardTemplate
                                : getProviderHtml(
                                    data.mlsOrg?.cardTemplate,
                                    data
                                );
                            data.mlsLogo = '';
                            if (data.mlsOrg) {
                                data.mlsLogo = this.isMobileSize
                                    ? data.mlsOrg.smallLogo
                                    : data.mlsOrg.logo;
                            }
                            if (
                                !util.isSSRServer &&
                                window.globalHouseDataFormat
                            ) {
                                window.globalHouseDataFormat(data, 'map');
                            }
                        });
                    }
                    if (type === 'school') {
                        this.showDisclaimer = true;
                    }
                    if (this.selectTab === type) {
                        flag = false;
                    }
                    tabs.push(item);
                }
            }
            if (flag) {
                this.normalMarkerShow = true;
            }
            this.tabs = tabs;
        },
        showBoundary(boundary, fit) {
            this.currentBoundaryIndex = fit
                ? this.siteMap.setCenter(
                    null,
                    null,
                    boundary,
                    this.boundaryColor
                )
                : this.siteMap.addBoundary(boundary, this.boundaryColor);
        },
        removeBoundary() {
            if (this.currentBoundaryIndex !== -1) {
                this.siteMap.clearBoundary(this.currentBoundaryIndex);
                this.currentBoundaryIndex = -1;
            }
        },
        updateMarkerData(data, isCover) {
            if (isCover) {
                this.markerData = data;
            } else {
                this.markerData = Object.assign(
                    {},
                    this.markerData,
                    data || {}
                );
            }
        },
        updateMarkerEvent(data) {
            this.markerEventMap = Object.assign(
                {},
                this.markerEventMap,
                data || {}
            );
        },
        updateMapClickEvent(fn) {
            this.mapClickEvent = fn;
        },
        doMapEvent(fn) {
            this.psMap.then(() => {
                util.call(fn, this);
            });
        },
        handleVisible(visible) {
            console.log(visible);
            this.visible = visible;
        },
        updateLocationMarker() {
            this.psMap.then(() => {
                this.markerData = Object.assign({}, this.markerData, {
                    location: this.address
                        ? {
                            address: this.address,
                            ...(this.center || this.siteMap.config.center)
                        }
                        : null
                });
            });
        },
        getWalkScore() {
            if (
                ['detail', 'detail-sold'].includes(this.mapType) &&
                this.mapData.lat &&
                this.mapData.lng
            ) {
                return this.axiosIns
                    .get(
                        '/api-site/getWalkScore?longitude=' +
                            this.mapData.lng +
                            '&latitude=' +
                            this.mapData.lat
                    )
                    .then(res => {
                        if (res && res.data) {
                            this.listingWalkScore = res.data;
                        }
                    });
            }
            return Promise.resolve({});
        },
        getUpData() {
            if (['nbrInfo', 'school-business'].includes(this.mapType)) {
                return this.axiosIns
                    .get('/api-site/place-data?fetcher=data&source=nbrUpData')
                    .then(res => {
                        let nbrUpData = res.data || {};
                        if (typeof nbrUpData === 'string') {
                            nbrUpData = JSON.parse(nbrUpData);
                        }
                        if (nbrUpData.selectTab !== undefined) {
                            this.selectTab = nbrUpData.selectTab;
                        }
                    });
            }
            if (['detail', 'detail-sold'].includes(this.mapType)) {
                return this.axiosIns
                    .get(
                        '/api-site/place-data?fetcher=data&source=detailMapUpData'
                    )
                    .then(res => {
                        let detailUpData = res.data || {};
                        if (typeof detailUpData === 'string') {
                            detailUpData = JSON.parse(detailUpData);
                        }
                        if (detailUpData.selectTab !== undefined) {
                            this.selectTab = detailUpData.selectTab;
                        }
                        if (detailUpData.miles !== undefined) {
                            this.miles = detailUpData.miles;
                            return this.getData();
                        }
                    });
            }
        }
    },
    components: {
        AttomDesc
    }
};
